import { emperor } from '~/services';

export const updateGroup = async (uuid: string, group: FormData) => {
  return await emperor.patch(`group/${uuid}`, group);
};
